import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV, LOGO_URL } from "@/data/site";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-300 ${
        scrolled
          ? "bg-[#f7f5f0]/90 backdrop-blur-md border-b border-black/[0.08]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-4 flex items-center justify-between">
        <a href="#top" data-testid="site-logo" className="flex items-center gap-3 group">
          <span className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden ring-1 ring-black/10 bg-white shrink-0">
            <img src={LOGO_URL} alt="Modo Motori" className="w-full h-full object-cover" />
          </span>
          <span className="font-display text-[20px] md:text-[22px] tighter font-medium text-[#121212]">
            Modo <span className="italic text-[#FF6B1A]">Motori</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#121212]/60 hover:text-[#FF6B1A] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <button
          data-testid="menu-toggle"
          className="md:hidden w-10 h-10 grid place-items-center rounded-md border border-black/15 text-[#121212]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden overflow-hidden border-t border-black/[0.08] bg-[#f7f5f0]"
          >
            <div className="px-5 py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="font-display text-2xl text-[#121212]">
                  {n.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
